module.exports = __webpack_public_path__ + "static/banner-mobile-594346de32244433de86d1e726c66a2a.png";